const checkIcon =
  'https://assets1.cleartax-cdn.com/clearsave/images/block_tick.svg';

export const BADGES = {
  timely_filer: {
    title: 'Timely Filer',
    description: 'No penalty',
    badgeImage:
      'https://assets1.cleartax-cdn.com/clearsave/images/badges/badge_use-cc.svg',
  },
  maxed_80_c: {
    title: 'Maxed out 80C',
    description: 'You are #1, saved the most on taxes',
    badgeImage:
      'https://assets1.cleartax-cdn.com/clearsave/images/badges/badge_use-coupon.svg',
  },
  visionary: {
    title: 'Visionary',
    description: 'You made sure to get health insurance',
    badgeImage:
      'https://assets1.cleartax-cdn.com/clearsave/images/badges/badge_use-phone.svg',
  },
  super_visionary: {
    title: 'Super Visionary',
    description: 'You made sure to get NPS! Only 0.05% of India does this!',
    badgeImage:
      'https://assets1.cleartax-cdn.com/clearsave/images/badges/badge_hidden-store.svg',
  },
  better_than_peers: {
    title: 'Better than peers',
    description:
      'You did better tax saving and growth than others at your company',
    badgeImage:
      'https://assets1.cleartax-cdn.com/clearsave/images/badges/badge_sale-item.svg',
  },
  sanskari: {
    title: 'Sanskari',
    description: 'You paid for parents’ health insurance!',
    badgeImage:
      'https://assets1.cleartax-cdn.com/clearsave/images/badges/badge_use-cc.svg',
  },
};

export const PLAN_RECOMMENDATIONS = {
  segment_a: {
    plan_name: 'Plan recommendation for Segment A',
    salary_bracket: 0,
    deduction_exhausted: null,
    age_bracket: null,
    plan_anchor_value: 5000,
    bucket_id: 26,
    bucket_title: 'Aggressive Growth Plan',
    bucket_description: 'Contains top mid, small & multi-cap funds',
    segment_pretitle:
      'Invest in this personalised money growth plan that gave 20% Returns over last 5 years',
    segment_title_underlined: '',
    segment_title_underlined_desc: '',
    segment_posttitle: '',
    segment_subtitle: '',
    pitch: [
      {
        icon: checkIcon,
        content: 'Start as low as Rs. 500.',
      },
      {
        icon: checkIcon,
        content: 'No lock-in period. Withdraw your money anytime.',
      },
      {
        icon: checkIcon,
        content: 'High growth funds. Investments doubled in just 4 years.',
      },
    ],
    benefits: [
      {
        img: 'icon-people.png',
        title: '25 yr olds with similar income are investing in these funds',
        desc:
          'Investors in your age and income range prefer to invest in aggressive mutual funds. Since age is on your side, investing long term reduces the risk to minimal',
      },
      {
        img: 'icon-returns.png',
        title: 'Better Returns than FD, PPF & Gold',
        desc:
          ' These funds have doubled the invested amount in 3 years, while other types of investment takes 10-12 years',
      },
      {
        img: 'icon-sip.png',
        title: 'Start a habit of investing. You can start small',
        desc:
          'Invested money grows while inflation eats saved money in bank account. MF returns consistently beat inflation.',
      },
      {
        img: 'icon-best-funds.png',
        title: 'Only the best funds',
        desc:
          'This plan comprises of consistently best performing funds of SBI, HDFC, Axis. Fund managers invest primarily in small and mid-cap companies.',
      },
    ],
  },
  segment_b: {
    plan_name: 'Plan recommendation for Segment B',
    salary_bracket: 1,
    deduction_exhausted: false,
    age_bracket: null,
    plan_anchor_value: 6000,
    bucket_id: 19,
    bucket_title: 'Tax Saving Plan',
    bucket_description: 'Contains top ELSS funds',
    segment_pretitle:
      'Invest in this personalized tax saving plan that could have helped you save more taxes than last year.',
    segment_title_underlined: '',
    segment_posttitle: '',
    segment_subtitle:
      'You could not utilize the full Rs.1.5 Lakhs in 80C. If you had invested in the below recommended plan by ClearTax, you would have made additional tax saving compared to last year.',
    pitch: [
      {
        icon: checkIcon,
        content:
          'Utilizing your 80C fully gives you more money than any other investment',
      },
      {
        icon: checkIcon,
        content:
          'Tax-saving funds (ELSS) have only 3 year lock-in period. FD, PPF have 5 - 15 year lock-in',
      },
      {
        icon: checkIcon,
        content:
          'Get much better returns than FD & PPF. These funds gave 15% return in last 3 years',
      },
    ],
    benefits: [
      {
        img: 'icon-80c.png',
        title: 'Easiest way to do your 80C',
        desc:
          "Investing in this plan is the easiest way to do your tax savings for the year. You can finish it in just a few minutes. It's much easier than investing in FD or PPF",
      },
      {
        img: 'icon-lock-in.png',
        title: 'Lowest lock-in & better returns than FD & PPF',
        desc:
          'These funds have doubled the invested amount in 3 years, while other types of investment takes 10-12 years',
      },
      {
        img: 'icon-best-funds.png',
        title: 'Expert selected funds',
        desc:
          'Our experts have chosen the best performing Tax Saving Funds that have consistently been Top Performing Funds in the past 10 years',
      },
      {
        img: 'icon-last-time.png',
        title: "Don't wait for the last minute. Invest Now.",
        desc:
          "It's easy to invest a Rs.3,000 every month till March. It may be very difficult to invest Rs.30,000 at the last minute",
      },
    ],
  },
  segment_c: {
    plan_name: 'Segment C2',
    salary_bracket: 1,
    deduction_exhausted: true,
    age_bracket: 1,
    plan_anchor_value: 7000,
    bucket_id: 26,
    bucket_title: 'Aggressive Growth Plan',
    bucket_description: 'Contains top mid, small & multi-cap funds',
    segment_pretitle:
      'Invest in this personalised money growth plan that gave 20% Returns.',
    segment_title_underlined: '',
    segment_posttitle: '',
    segment_subtitle:
      'Have you ever tried your hand at mutual funds and got lost? Don’t get confused by thousands of mutual funds, here are the top performing funds for you hand picked by industry experts.',
    pitch: [
      {
        icon: checkIcon,
        content: 'Start as low as Rs.2000',
      },
      {
        icon: checkIcon,
        content: 'No lock-in period. Withdraw your money anytime.',
      },
      {
        icon: checkIcon,
        content: 'High growth funds. Investments doubled in just 3 years.',
      },
    ],
    benefits: [
      {
        img: 'icon-people.png',
        title: '25 yr olds with similar income are investing in these funds',
        desc:
          'Investors in your age and income range prefer to invest in aggressive mutual funds. Since age is on your side, investing long term reduces the risk to minimal',
      },
      {
        img: 'icon-returns.png',
        title: 'Better Returns than FD, PPF & Gold',
        desc:
          ' These funds have doubled the invested amount in 3 years, while other types of investment takes 10-12 years',
      },
      {
        img: 'icon-sip.png',
        title: 'Start a habit of investing. You can start small',
        desc:
          'Invested money grows while inflation eats saved money in bank account. MF returns consistently beat inflation.',
      },
      {
        img: 'icon-best-funds.png',
        title: 'Only the best funds',
        desc:
          'This plan comprises of consistently best performing funds of SBI, HDFC, Axis. Fund managers invest primarily in small and mid-cap companies.',
      },
    ],
  },
  segment_d: {
    plan_name: 'Segment D',
    salary_bracket: 1,
    deduction_exhausted: true,
    age_bracket: 2,
    plan_anchor_value: 8000,
    bucket_id: 22,
    bucket_title: 'Balanced Growth Plan',
    bucket_description: 'Contains top large, mid-cap & debt funds',
    segment_pretitle:
      'Invest in this personalised investment plan for an overall balanced growth.',
    segment_title_underlined: '',
    segment_posttitle: '',
    segment_subtitle:
      'Have you ever tried your hand at mutual funds and got lost? Don’t get confused by thousands of mutual funds, here are the top performing funds for you hand picked by industry experts.',
    pitch: [
      {
        icon: checkIcon,
        content: 'Best funds across debt and equity (large & mid cap)',
      },
      {
        icon: checkIcon,
        content: 'No lock-in period. Withdraw your money anytime.',
      },
      {
        icon: checkIcon,
        content: 'Balanced growth funds. Investments doubled in just 5 years.',
      },
    ],
    benefits: [
      {
        img: 'icon-people.png',
        title: '40 yr olds with similar income are investing in these funds',
        desc:
          'Investors in your age and income range prefer to invest in balanced growth funds. Since age is on your side, investing long term reduces the risk to minimal',
      },
      {
        img: 'icon-best-funds.png',
        title: 'Only the best funds',
        desc:
          'No need to research from the thousand funds. We only suggest top performing funds for you hand picked by industry experts',
      },
      {
        img: 'icon-sip.png',
        title: 'Experience the easiest way of investing. Start a SIP',
        desc:
          'ClearTax offers you seamless investment experience – finish investing in just a few minutes.',
      },
    ],
  },
  segment_e: {
    plan_name: 'Plan recommendation for Segment E',
    salary_bracket: 1,
    deduction_exhausted: true,
    age_bracket: 3,
    plan_anchor_value: 9000,
    bucket_id: 26,
    bucket_title: 'growth fund',
    bucket_description:
      'This plan contains two high-performing mutual funds. These funds have performed consistently well given the risk they have taken',
    segment_pretitle: 'Here is a personalised plan for you that gave',
    segment_title_underlined: '20% Returns last year',
    segment_posttitle: '. ',
    segment_subtitle: '',
    pitch: [
      {
        icon: checkIcon,
        content: 'Get up to 55% return annually',
      },
      {
        icon: checkIcon,
        content:
          'If you invested in this plan 3 years ago, your money would’ve doubled',
      },
      {
        icon: checkIcon,
        content:
          'These are the best Mutual Funds based on your income, age, earning goals & spending pattern',
      },
    ],
    benefits: [
      {
        img: 'icon-wallet.png',
        title: 'Upto 3x better returns than Bank Deposits',
        desc:
          'These funds on averge given three time more returns (~18%) than your bank deposit interest (~4.5%)',
      },
      {
        img: 'icon-balance.png',
        title: 'Risk Diversified for potential rewards',
        desc:
          'Diversified mutual fund investments and thier expert fund managers increase the chances of a higher returns',
      },
      {
        img: 'icon-balance.png',
        title: 'Any time Withdrawal',
        desc:
          'Your investments could be stopped (in case of monthly SIP) or withdrawn anytime',
      },
      {
        img: 'icon-lock.png',
        title: 'Best time to Invest in India',
        desc:
          'Investing in mutual funds, shows your belief in India growth story for the next 5 years',
      },
      {
        img: 'icon-piggy.png',
        title: 'Start small and grow big',
        desc:
          'Did you know? Rs.1000 invested every month in mutual funds could give your upt 1 crore corpus (@15% p.a)',
      },
    ],
  },
  segment_f1: {
    plan_name: 'Plan recommendation for Segment F1',
    salary_bracket: 0,
    deduction_exhausted: null,
    age_bracket: null,
    plan_anchor_value: 5000,
    bucket_id: 26,
    bucket_title: 'Aggressive Growth Plan',
    bucket_description: 'Contains top mid, small & multi-cap funds',
    segment_pretitle:
      'Invest in this personalised money growth plan that gave 20% Returns over last 5 years',
    segment_title_underlined: '',
    segment_title_underlined_desc: '',
    segment_posttitle: '',
    segment_subtitle: '',
    pitch: [
      {
        icon: checkIcon,
        content: 'Start as low as Rs. 2000.',
      },
      {
        icon: checkIcon,
        content: 'No lock-in period. Withdraw your money anytime.',
      },
      {
        icon: checkIcon,
        content: 'High growth funds. Investments doubled in just 4 years.',
      },
    ],
    benefits: [
      {
        img: 'icon-people.png',
        title: '25 yr olds with similar income are investing in these funds',
        desc:
          'Investors in your age and income range prefer to invest in aggressive mutual funds. Since age is on your side, investing long term reduces the risk to minimal',
      },
      {
        img: 'icon-returns.png',
        title: 'Better Returns than FD, PPF & Gold',
        desc:
          ' These funds have doubled the invested amount in 3 years, while other types of investment takes 10-12 years',
      },
      {
        img: 'icon-sip.png',
        title: 'Start a habit of investing. You can start small',
        desc:
          'Invested money grows while inflation eats saved money in bank account. MF returns consistently beat inflation.',
      },
      {
        img: 'icon-best-funds.png',
        title: 'Only the best funds',
        desc:
          'This plan comprises of consistently best performing funds of SBI, HDFC, Axis. Fund managers invest primarily in small and mid-cap companies.',
      },
    ],
  },
  segment_f2: {
    plan_name: 'Segment D',
    salary_bracket: 1,
    deduction_exhausted: true,
    age_bracket: 2,
    plan_anchor_value: 8000,
    bucket_id: 22,
    bucket_title: 'Balanced Growth Plan',
    bucket_description: 'Contains top large, mid-cap & debt funds',
    segment_pretitle:
      'Invest in this personalised investment plan for an overall balanced growth.',
    segment_title_underlined: '',
    segment_posttitle: '',
    segment_subtitle:
      'Have you ever tried your hand at mutual funds and got lost? Don’t get confused by thousands of mutual funds, here are the top performing funds for you hand picked by industry experts.',
    pitch: [
      {
        icon: checkIcon,
        content: 'Best funds across debt and equity (large & mid cap)',
      },
      {
        icon: checkIcon,
        content: 'No lock-in period. Withdraw your money anytime.',
      },
      {
        icon: checkIcon,
        content: 'Balanced growth funds. Investments doubled in just 5 years.',
      },
    ],
    benefits: [
      {
        img: 'icon-people.png',
        title: '40 yr olds with similar income are investing in these funds',
        desc:
          'Investors in your age and income range prefer to invest in balanced growth funds. Since age is on your side, investing long term reduces the risk to minimal',
      },
      {
        img: 'icon-best-funds.png',
        title: 'Only the best funds',
        desc:
          'No need to research from the thousand funds. We only suggest top performing funds for you hand picked by industry experts',
      },
      {
        img: 'icon-sip.png',
        title: 'Experience the easiest way of investing. Start a SIP',
        desc:
          'ClearTax offers you seamless investment experience – finish investing in just a few minutes.',
      },
    ],
  },
};

export const PLAN_BENEFITS = [
  {
    img: 'icon-wallet.png',
    title: 'Upto 3x better returns than Bank Deposits',
    desc:
      'These funds on averge given three time more returns (~18%) than your bank deposit interest (~4.5%)',
  },
  {
    img: 'icon-balance.png',
    title: 'Risk Diversified for potential rewards',
    desc:
      'Diversified mutual fund investments and thier expert fund managers increase the chances of a higher returns',
  },
  {
    img: 'icon-balance.png',
    title: 'Any time Withdrawal',
    desc:
      'Your investments could be stopped (in case of monthly SIP) or withdrawn anytime',
  },
  {
    img: 'icon-lock.png',
    title: 'Best time to Invest in India',
    desc:
      'Investing in mutual funds, shows your belief in India growth story for the next 5 years',
  },
  {
    img: 'icon-piggy.png',
    title: 'Start small and grow big',
    desc:
      'Did you know? Rs.1000 invested every month in mutual funds could give your upt 1 crore corpus (@15% p.a)',
  },
];

// buckets
export const FOR_THE_YOUNG_INDIA = {
  products: [
    {
      fundName: 'DSP Midcap Fund',
      issuingAuthority: 'DSP Mutual Fund',
      year: 2006,
      schemeCode: '104',
      amfiSchemeCode: '104481',
      currentNav: 54.529,
      amcCode: 'D',
      lockinPeriod: 5,
      annualInterestRate: 16.91,
      fundType: 'NONELSS',
      imageUrl: '/images/DSP.png',
      fundHouse: 'CAMS',
      morningStarRating: '3/5',
      valueResearchRating: '3/5',
      threeYearReturns: 21.02,
      fiveYearReturns: 26.44,
      minAmount: 1000,
      minSipAmount: 500,
      minRedeemableAmount: 500,
      minRedeemableUnit: 5,
      productCode: 'D104',
      exitLoad: 1,
      priority: 6,
      type: 'MidCapEquity',
      productId: 6,
      fundFocus:
        'Invests in shares of emerging mid-sized and high-potential small-sized companies',
      supportedItemTypes: ['LUMPSUM_MF', 'SIP_MF'],
    },
    {
      fundName: 'HDFC Mid-Cap Opportunities Fund',
      issuingAuthority: 'HDFC Mutual Fund',
      year: 2007,
      schemeCode: 'MCOG',
      amfiSchemeCode: '105758',
      currentNav: 56.13,
      amcCode: 'H',
      lockinPeriod: 5,
      annualInterestRate: 17.87,
      fundType: 'NONELSS',
      imageUrl: '/images/HDFC.png',
      fundHouse: 'CAMS',
      morningStarRating: '4/5',
      valueResearchRating: '4/5',
      threeYearReturns: 20.45,
      fiveYearReturns: 27.25,
      minAmount: 5000,
      minSipAmount: 500,
      minRedeemableAmount: 500,
      minRedeemableUnit: 5,
      productCode: 'HMCOG',
      exitLoad: 1,
      priority: 35,
      type: 'MidCapEquity',
      productId: 35,
      fundFocus: 'Invests in shares of mid-sized emerging companies',
      supportedItemTypes: ['LUMPSUM_MF', 'SIP_MF'],
    },
    {
      fundName: 'SBI Magnum Multicap',
      issuingAuthority: 'SBI Mutual Fund',
      year: 2005,
      schemeCode: '099G',
      amfiSchemeCode: '103215',
      currentNav: 46.5867,
      amcCode: 'L',
      lockinPeriod: 5,
      annualInterestRate: 13.22,
      fundType: 'NONELSS',
      imageUrl: '/images/SBI.png',
      fundHouse: 'CAMS',
      morningStarRating: '5/5',
      valueResearchRating: '5/5',
      threeYearReturns: 19.95,
      fiveYearReturns: 21.07,
      minAmount: 1000,
      minSipAmount: 500,
      minRedeemableAmount: 500,
      minRedeemableUnit: 5,
      productCode: 'L099G',
      exitLoad: 1,
      priority: 31,
      type: 'MultiCapEquity',
      productId: 31,
      fundFocus:
        'Invests in shares of large-sized top 100 and mid-sized emerging companies',
      supportedItemTypes: ['LUMPSUM_MF'],
    },
  ],
  alternativeProducts: [
    {
      fundName: 'HDFC Small Cap Fund',
      issuingAuthority: 'HDFC Mutual Fund',
      year: 2008,
      schemeCode: 'ACGPG',
      amfiSchemeCode: '130502',
      currentNav: 45.179,
      amcCode: 'H',
      lockinPeriod: 5,
      annualInterestRate: 15.45,
      fundType: 'NONELSS',
      imageUrl: '/images/HDFC.png',
      fundHouse: 'CAMS',
      morningStarRating: '4/5',
      valueResearchRating: '3/5',
      threeYearReturns: 20.57,
      fiveYearReturns: 25.32,
      minAmount: 5000,
      minSipAmount: 500,
      minRedeemableAmount: 500,
      minRedeemableUnit: 5,
      productCode: 'HACGPG',
      exitLoad: 1,
      priority: 25,
      type: 'SmallCapEquity',
      productId: 26,
      fundFocus:
        'Invests in shares of emerging mid-sized and high-potential small-sized companies',
      supportedItemTypes: ['LUMPSUM_MF', 'SIP_MF'],
    },
    {
      fundName: 'DSP Equity Opportunities Fund',
      issuingAuthority: 'DSP Mutual Fund',
      year: 2000,
      schemeCode: '66',
      amfiSchemeCode: '103819',
      currentNav: 213.038,
      amcCode: 'D',
      lockinPeriod: 5,
      annualInterestRate: 19.03,
      fundType: 'NONELSS',
      imageUrl: '/images/DSP.png',
      fundHouse: 'CAMS',
      morningStarRating: '5/5',
      valueResearchRating: '4/5',
      threeYearReturns: 16.76,
      fiveYearReturns: 21.9,
      minAmount: 1000,
      minSipAmount: 500,
      minRedeemableAmount: 500,
      minRedeemableUnit: 5,
      productCode: 'D66',
      exitLoad: 1,
      priority: 37,
      type: 'MultiCapEquity',
      productId: 38,
      fundFocus: '',
      supportedItemTypes: ['LUMPSUM_MF', 'SIP_MF'],
    },
  ],
  minAmountForBucket: 7000,
  minSipAmountForBucket: 1500,
  minRedeemableAmountForBucket: 1500,
  minRedeemableUnitForBucket: 15,
  bucketId: 'c282c713-6589-11e8-bedb-0a1ac60a80f8',
  sections: {
    title: 'For the Young India',
    amount: 3000,
    bucketId: '26',
    rating: {
      rating: 4,
      returnLabel: '5Y Return',
      returns: '24.9',
    },
    actionButton: {
      actionButtonLabel: 'Invest Now',
      actionButtonLink: '/save',
      color: '',
    },
    benefits: {
      benefitsLabel: 'Benefits',
      benefits: [
        'Just started working?',
        'Get into habit of investing',
        'Grow wealth for cost of beer and pizza over weekends',
      ],
    },
    funds: {
      fundsLabel: 'Funds in the basket',
      funds: [
        {
          title: 'HDFC Mid Cap Opportunities Fund',
          image: 'HDFC.png',
          fundLink: '#',
        },
        {
          title: 'DSP Midcap Fund - Regular Plan',
          image: 'DSP.png',
          fundLink: '#',
        },
        {
          title: 'SBI Bluechip Fund',
          image: 'SBI.png',
          fundLink: '#',
        },
      ],
    },
    popupData: {
      basic: {
        title: 'Basic Details',
        details: [
          {
            label: 'Min. SIP',
            value: '₹1,500',
            tooltip: 'The actual values may vary based on funds',
          },
          {
            label: 'Min. Investment',
            value: '₹20,000',
          },
        ],
      },
      moreDetails: {
        title: 'More about these funds',
        details: [
          {
            header: 'Best suited for',
            content:
              'This scheme is meant for individuals who have just begun their career path. It gives them an opportunity to invest and accumulate wealth through steady stepping-up of SIPs and taking higher risks over long-term investment horizon.',
          },
          {
            header: 'Why invest in these funds?',
            content:
              "The mutual fund scheme delivers higher returns as compared to its peer funds for the same level of risk taken. Additionally, the fund manager is better positioned to manage scheme's asset so as to formulate low-cost investment strategies that generate higher returns. With its unique investment style combined with more than 80% investment in large caps, the fund manager maintains a well-diversified portfolio to keep risk under manageable levels.",
          },
        ],
      },
      fundDetails: {
        title: 'You will be investing in the following funds',
        funds: [
          {
            name: 'ICICI Prudential Focused Bluechip Equity Fund',
            image: 'ICICI.png',
            details: [
              {
                label: 'Rating',
                value: 4,
                type: 'rating',
              },
              {
                label: '5Y Return',
                value: '17.1%',
              },
              {
                label: 'AUM',
                value: '16,275 Cr',
              },
              {
                label: 'Category',
                value: 'Equity',
              },
            ],
          },
          {
            name: 'HDFC Mid Cap Opportunities Fund',
            image: 'HDFC.png',
            details: [
              {
                label: 'Rating',
                value: 4,
                type: 'rating',
              },
              {
                label: '5Y Return',
                value: '27.7%',
              },
              {
                label: 'AUM',
                value: '19,339 Cr',
              },
              {
                label: 'Category',
                value: 'Equity',
              },
            ],
          },
          {
            name: 'DSP Midcap Fund - Regular Plan',
            image: 'DSP.png',
            details: [
              {
                label: 'Rating',
                value: 4,
                type: 'rating',
              },
              {
                label: '5Y Return',
                value: '28.6%',
              },
              {
                label: 'AUM',
                value: '5,390 Cr',
              },
              {
                label: 'Category',
                value: 'Equity',
              },
            ],
          },
          {
            name: 'Reliance Small Cap Fund',
            image: 'Reliance.png',
            details: [
              {
                label: 'Rating',
                value: 5,
                type: 'rating',
              },
              {
                label: '5Y Return',
                value: '37.8%',
              },
              {
                label: 'AUM',
                value: '6,545 Cr',
              },
              {
                label: 'Category',
                value: 'Equity',
              },
            ],
          },
        ],
      },
    },
  },
  enabled: false,
};

export const BETTER_THAN_FD = {
  products: [
    {
      fundName: 'ICICI Prudential Short Term Fund',
      issuingAuthority: 'ICICI Prudential Mutual Fund',
      year: 0,
      schemeCode: '24',
      amfiSchemeCode: '101758',
      currentNav: 36.1375,
      amcCode: 'P',
      lockinPeriod: 5,
      annualInterestRate: 8.15,
      fundType: 'NONELSS',
      imageUrl: '/images/ICICI.png',
      fundHouse: 'CAMS',
      morningStarRating: '3/5',
      valueResearchRating: '3',
      threeYearReturns: 8.2,
      fiveYearReturns: 8.2,
      minAmount: 5000,
      minSipAmount: 1000,
      minRedeemableAmount: 500,
      minRedeemableUnit: 5,
      productCode: 'P24',
      exitLoad: 0.25,
      priority: 69,
      type: 'ShortTermDebt',
      productId: 69,
      fundFocus: 'Invests mainly in debt of very safe companies',
      supportedItemTypes: [],
    },
    {
      fundName: 'HDFC Short Term Debt Fund',
      issuingAuthority: 'HDFC Mutual Fund',
      year: 2010,
      schemeCode: 'STOG',
      amfiSchemeCode: '113047',
      currentNav: 19.2295,
      amcCode: 'H',
      lockinPeriod: 5,
      annualInterestRate: 8.77,
      fundType: 'NONELSS',
      imageUrl: '/images/HDFC.png',
      fundHouse: 'CAMS',
      morningStarRating: '5/5',
      valueResearchRating: '4/5',
      threeYearReturns: 8.04,
      fiveYearReturns: 8.31,
      minAmount: 5000,
      minSipAmount: 1000,
      minRedeemableAmount: 500,
      minRedeemableUnit: 5,
      productCode: 'HSTOG',
      exitLoad: 0,
      priority: 61,
      type: 'ShortTermDebt',
      productId: 61,
      fundFocus: 'Invests mainly in debt of very safe companies',
      supportedItemTypes: ['LUMPSUM_MF', 'SIP_MF'],
    },
    {
      fundName: 'Aditya Birla SL Medium Term Plan',
      issuingAuthority: 'Birla Sun Life Mutual Fund',
      year: 2009,
      schemeCode: '303G',
      amfiSchemeCode: '111803',
      currentNav: 22.002,
      amcCode: 'B',
      lockinPeriod: 5,
      annualInterestRate: 9.14,
      fundType: 'NONELSS',
      imageUrl: '/images/Birla.png',
      fundHouse: 'CAMS',
      morningStarRating: '2/5',
      valueResearchRating: '2/5',
      threeYearReturns: 8.9,
      fiveYearReturns: 9.44,
      minAmount: 1000,
      minSipAmount: 1000,
      minRedeemableAmount: 500,
      minRedeemableUnit: 5,
      productCode: 'B303G',
      exitLoad: 1,
      priority: 59,
      type: 'CreditOpportunitiesDebt',
      productId: 59,
      fundFocus: 'Invests mainly in debt of very safe companies',
      supportedItemTypes: ['LUMPSUM_MF', 'SIP_MF'],
    },
  ],
  alternativeProducts: [
    {
      fundName: 'SBI Magnum Constant Maturity Fund',
      issuingAuthority: 'SBI Mutual Fund',
      year: 0,
      schemeCode: '038',
      amfiSchemeCode: '101002',
      currentNav: 36.9561,
      amcCode: 'L',
      lockinPeriod: 5,
      annualInterestRate: 7.85,
      fundType: 'NONELSS',
      imageUrl: '/images/SBI.png',
      fundHouse: 'CAMS',
      morningStarRating: '5/5',
      valueResearchRating: '4',
      threeYearReturns: 8.84,
      fiveYearReturns: 9.6,
      minAmount: 5000,
      minSipAmount: 1000,
      minRedeemableAmount: 500,
      minRedeemableUnit: 5,
      productCode: 'L38',
      exitLoad: 0,
      priority: 64,
      type: 'GiltShortTermDebt',
      productId: 65,
      fundFocus: '',
      supportedItemTypes: [],
    },
    {
      fundName: 'ICICI Prudential Savings Fund',
      issuingAuthority: 'ICICI Prudential Mutual Fund',
      year: 0,
      schemeCode: '1525',
      amfiSchemeCode: '101619',
      currentNav: 334.452,
      amcCode: 'P',
      lockinPeriod: 5,
      annualInterestRate: 8.07,
      fundType: 'NONELSS',
      imageUrl: '/images/ICICI.png',
      fundHouse: 'CAMS',
      morningStarRating: '5/5',
      valueResearchRating: '3',
      threeYearReturns: 8.23,
      fiveYearReturns: 8.6,
      minAmount: 500,
      minSipAmount: 500,
      minRedeemableAmount: 500,
      minRedeemableUnit: 5,
      productCode: 'P1525',
      exitLoad: 0,
      priority: 66,
      type: 'UltraShortTermDebt',
      productId: 67,
      fundFocus: 'Invests in short duration debt to safe companies ',
      supportedItemTypes: [],
    },
  ],
  minAmountForBucket: 11000,
  minSipAmountForBucket: 3000,
  minRedeemableAmountForBucket: 1500,
  minRedeemableUnitForBucket: 15,
  bucketId: 'c282bce0-6589-11e8-bedb-0a1ac60a80f8',
  sections: {
    title: 'Better than FD',
    amount: 3000,
    bucketId: '20',
    rating: {
      rating: 5,
      returnLabel: '5Y Return',
      returns: '8.7',
    },
    actionButton: {
      actionButtonLabel: 'Invest Now',
      actionButtonLink: '/save',
      color: '',
    },
    benefits: {
      benefitsLabel: 'Benefits',
      benefits: [
        'New to investing? Start here',
        'Growth and safety',
        'Higher returns than FD',
        'No Lock-in period',
      ],
    },
    funds: {
      fundsLabel: 'Funds in the basket',
      funds: [
        {
          title: 'HDFC Short Term Opportunities Fund',
          image: 'HDFC.png',
          fundLink: '#',
        },
        {
          title: 'ICICI Prudential Short Term Plan',
          image: 'ICICI.png',
          fundLink: '#',
        },
        {
          title: 'Aditya Birla Sun Life Medium Term Plan',
          image: 'Birla.png',
          fundLink: '#',
        },
      ],
    },
    popupData: {
      basic: {
        title: 'Basic Details',
        details: [
          {
            label: 'Min. SIP',
            value: '₹3,000',
            tooltip: 'The actual values may vary based on funds',
          },
          {
            label: 'Min. Investment',
            value: '₹16,000',
          },
        ],
      },
      moreDetails: {
        title: 'More about these funds',
        details: [
          {
            header: 'Best suited for',
            content:
              'The scheme is essentially made for conservative investors who have a medium-term investment horizon and want to earn higher returns than a regular bank FD.',
          },
          {
            header: 'Why invest in these funds?',
            content:
              'The fund manager essentially invests in high credit-rating corporate securities which deliver higher returns and the continuous rebalancing of portfolio is done to take advantage of return rate fluctuations.',
          },
        ],
      },
      fundDetails: {
        title: 'You will be investing in the following funds',
        funds: [
          {
            name: 'Aditya Birla Sun Life Savings Fund',
            image: 'Birla.png',
            details: [
              {
                label: 'Rating',
                value: 5,
                type: 'rating',
              },
              {
                label: '5Y Return',
                value: '8.8%',
              },
              {
                label: 'AUM',
                value: '22,879 Cr',
              },
              {
                label: 'Category',
                value: 'Debt',
              },
            ],
          },
          {
            name: 'HDFC Short Term Opportunities Fund',
            image: 'HDFC.png',
            details: [
              {
                label: 'Rating',
                value: 4,
                type: 'rating',
              },
              {
                label: '5Y Return',
                value: '8.6%',
              },
              {
                label: 'AUM',
                value: '9,925 Cr',
              },
              {
                label: 'Category',
                value: 'Debt',
              },
            ],
          },
          {
            name: 'ICICI Prudential Short Term Plan',
            image: 'ICICI.png',
            details: [
              {
                label: 'Rating',
                value: 5,
                type: 'rating',
              },
              {
                label: '5Y Return',
                value: '11.0%',
              },
              {
                label: 'AUM',
                value: '8,813 Cr',
              },
              {
                label: 'Category',
                value: 'Debt',
              },
            ],
          },
          {
            name: 'Aditya Birla Sun Life Medium Term Plan',
            image: 'Birla.png',
            details: [
              {
                label: 'Rating',
                value: 5,
                type: 'rating',
              },
              {
                label: '5Y Return',
                value: '9.8%',
              },
              {
                label: 'AUM',
                value: '11,505 Cr',
              },
              {
                label: 'Category',
                value: 'Debt',
              },
            ],
          },
        ],
      },
    },
  },
  enabled: false,
};

export const GROW_RICH = {
  products: [
    {
      fundName: 'SBI Bluechip Fund',
      issuingAuthority: 'SBI Mutual Fund',
      year: 0,
      schemeCode: '103G',
      amfiSchemeCode: '103504',
      currentNav: 38.0506,
      amcCode: 'L',
      lockinPeriod: 5,
      annualInterestRate: 11.68,
      fundType: 'NONELSS',
      imageUrl: '/images/SBI.png',
      fundHouse: 'CAMS',
      morningStarRating: '4/5',
      valueResearchRating: '5',
      threeYearReturns: 9.66,
      fiveYearReturns: 18.29,
      minAmount: 5000,
      minSipAmount: 500,
      minRedeemableAmount: 500,
      minRedeemableUnit: 5,
      productCode: 'L103G',
      exitLoad: 1,
      priority: 64,
      type: 'LargeCapEquity',
      productId: 64,
      fundFocus: 'Invests in shares of large-sized top 100 companies',
      supportedItemTypes: [],
    },
    {
      fundName: 'DSP Midcap Fund',
      issuingAuthority: 'DSP Mutual Fund',
      year: 2006,
      schemeCode: '104',
      amfiSchemeCode: '104481',
      currentNav: 54.529,
      amcCode: 'D',
      lockinPeriod: 5,
      annualInterestRate: 16.91,
      fundType: 'NONELSS',
      imageUrl: '/images/DSP.png',
      fundHouse: 'CAMS',
      morningStarRating: '3/5',
      valueResearchRating: '3/5',
      threeYearReturns: 21.02,
      fiveYearReturns: 26.44,
      minAmount: 1000,
      minSipAmount: 500,
      minRedeemableAmount: 500,
      minRedeemableUnit: 5,
      productCode: 'D104',
      exitLoad: 1,
      priority: 6,
      type: 'MidCapEquity',
      productId: 6,
      fundFocus:
        'Invests in shares of emerging mid-sized and high-potential small-sized companies',
      supportedItemTypes: ['LUMPSUM_MF', 'SIP_MF'],
    },
    {
      fundName: 'ICICI Prudential Balanced Advantage Fund',
      issuingAuthority: 'ICICI Prudential Mutual Fund',
      year: 0,
      schemeCode: 'EDWRG',
      amfiSchemeCode: '104685',
      currentNav: 33.65,
      amcCode: 'P',
      lockinPeriod: 5,
      annualInterestRate: 11.34,
      fundType: 'NONELSS',
      imageUrl: '/images/ICICI.png',
      fundHouse: 'CAMS',
      morningStarRating: '4/5',
      valueResearchRating: '3',
      threeYearReturns: 9.27,
      fiveYearReturns: 14.46,
      minAmount: 5000,
      minSipAmount: 1000,
      minRedeemableAmount: 500,
      minRedeemableUnit: 5,
      productCode: 'PEDWRG',
      exitLoad: 1,
      priority: 70,
      type: 'EquityOrientedHybrid',
      productId: 70,
      fundFocus:
        'Invests in shares of large-sized top 100 companies and in debt',
      supportedItemTypes: [],
    },
  ],
  alternativeProducts: [
    {
      fundName: 'SBI Magnum Multicap',
      issuingAuthority: 'SBI Mutual Fund',
      year: 2005,
      schemeCode: '099G',
      amfiSchemeCode: '103215',
      currentNav: 46.5867,
      amcCode: 'L',
      lockinPeriod: 5,
      annualInterestRate: 13.22,
      fundType: 'NONELSS',
      imageUrl: '/images/SBI.png',
      fundHouse: 'CAMS',
      morningStarRating: '5/5',
      valueResearchRating: '5/5',
      threeYearReturns: 19.95,
      fiveYearReturns: 21.07,
      minAmount: 1000,
      minSipAmount: 500,
      minRedeemableAmount: 500,
      minRedeemableUnit: 5,
      productCode: 'L099G',
      exitLoad: 1,
      priority: 30,
      type: 'MultiCapEquity',
      productId: 31,
      fundFocus:
        'Invests in shares of large-sized top 100 and mid-sized emerging companies',
      supportedItemTypes: ['LUMPSUM_MF'],
    },
    {
      fundName: 'Reliance Small Cap Fund',
      issuingAuthority: 'Reliance Mutual Fund',
      year: 2010,
      schemeCode: 'SCGP',
      amfiSchemeCode: '113177',
      currentNav: 42.377,
      amcCode: 'RMF',
      lockinPeriod: 5,
      annualInterestRate: 22.55,
      fundType: 'NONELSS',
      imageUrl: '/images/Reliance.png',
      fundHouse: 'KARVY',
      morningStarRating: '5/5',
      valueResearchRating: '3/5',
      threeYearReturns: 23.69,
      fiveYearReturns: 37.9,
      minAmount: 5000,
      minSipAmount: 500,
      minRedeemableAmount: 100,
      minRedeemableUnit: 5,
      productCode: 'RMFSCGP',
      exitLoad: 1,
      priority: 7,
      type: 'SmallCapEquity',
      productId: 8,
      fundFocus: null,
      supportedItemTypes: ['LUMPSUM_MF', 'SIP_MF'],
    },
  ],
  minAmountForBucket: 11000,
  minSipAmountForBucket: 2000,
  minRedeemableAmountForBucket: 1500,
  minRedeemableUnitForBucket: 15,
  bucketId: 'c282bf28-6589-11e8-bedb-0a1ac60a80f8',
  sections: {},
  enabled: false,
};

export const TAX_SAVER_PLANS = {
  products: [
    {
      fundName: 'ICICI Prudential Long Term Equity Fund (Tax Saving)',
      issuingAuthority: 'ICICI Prudential Mutual Fund',
      year: 0,
      schemeCode: '01',
      amfiSchemeCode: '100354',
      currentNav: 350.27,
      amcCode: 'P',
      lockinPeriod: 1096,
      annualInterestRate: 21.11,
      fundType: 'ELSS',
      imageUrl: '/images/ICICI.png',
      fundHouse: 'CAMS',
      morningStarRating: '4/5',
      valueResearchRating: '2',
      threeYearReturns: 8.85,
      fiveYearReturns: 18.93,
      minAmount: 500,
      minSipAmount: 500,
      minRedeemableAmount: 500,
      minRedeemableUnit: 5,
      productCode: 'P01',
      exitLoad: 0,
      priority: 4,
      type: 'ELSSEquity',
      productId: 66,
      fundFocus: 'Invests in shares of large-sized top 100 companies',
      supportedItemTypes: [],
    },
    {
      fundName: 'DSP Tax Saver Fund',
      issuingAuthority: 'DSP Mutual Fund',
      year: 2014,
      schemeCode: '110',
      amfiSchemeCode: '104772',
      currentNav: 44.922,
      amcCode: 'D',
      lockinPeriod: 1096,
      annualInterestRate: 15.54,
      fundType: 'ELSS',
      imageUrl: '/images/DSP.png',
      fundHouse: 'CAMS',
      morningStarRating: '4/5',
      valueResearchRating: '4/5',
      threeYearReturns: 26.31,
      fiveYearReturns: 20.32,
      minAmount: 500,
      minSipAmount: 500,
      minRedeemableAmount: 500,
      minRedeemableUnit: 5,
      productCode: 'D110',
      exitLoad: null,
      priority: 2,
      type: 'ELSSEquity',
      productId: 3,
      fundFocus: 'Invests in shares of large-sized top 100 companies',
      supportedItemTypes: ['LUMPSUM_MF', 'SIP_MF'],
    },
    {
      fundName: 'Aditya Birla Sun Life Tax Relief 96',
      issuingAuthority: 'Birla Sun Life Mutual Fund',
      year: 1996,
      schemeCode: '02G',
      amfiSchemeCode: '107745',
      currentNav: 31.3,
      amcCode: 'B',
      lockinPeriod: 1096,
      annualInterestRate: 26.08,
      fundType: 'ELSS',
      imageUrl: '/images/Birla.png',
      fundHouse: 'CAMS',
      morningStarRating: '4/5',
      valueResearchRating: '5/5',
      threeYearReturns: 18.11,
      fiveYearReturns: 22.83,
      minAmount: 500,
      minSipAmount: 500,
      minRedeemableAmount: 500,
      minRedeemableUnit: 5,
      productCode: 'B02G',
      exitLoad: 0,
      priority: 1,
      type: 'ELSSEquity',
      productId: 52,
      fundFocus: 'Invests in shares of mid-sized emerging companies',
      supportedItemTypes: ['LUMPSUM_MF', 'SIP_MF'],
    },
    {
      fundName: 'Axis Long Term Equity Fund',
      issuingAuthority: 'Axis Mutual Fund',
      year: 2014,
      schemeCode: 'TSGPG',
      amfiSchemeCode: '112323',
      currentNav: 43.0083,
      amcCode: 'AXF',
      lockinPeriod: 1096,
      annualInterestRate: 19.46,
      fundType: 'ELSS',
      imageUrl: '/img/funds/axis.png',
      fundHouse: 'Karvy',
      morningStarRating: '4/5',
      valueResearchRating: '4/5',
      threeYearReturns: 24.38,
      fiveYearReturns: 23.73,
      minAmount: 500,
      minSipAmount: 500,
      minRedeemableAmount: 500,
      minRedeemableUnit: 5,
      productCode: '128TSGP',
      exitLoad: null,
      priority: 3,
      type: 'ELSSEquity',
      productId: 4,
      fundFocus: 'Invests in shares of large-sized top 100 companies',
      supportedItemTypes: ['LUMPSUM_MF', 'SIP_MF'],
    },
  ],
  alternativeProducts: [
    {
      fundName: 'Reliance Tax Saver Fund',
      issuingAuthority: 'Reliance Mutual Fund',
      year: 2014,
      schemeCode: 'TSGP',
      amfiSchemeCode: '103196',
      currentNav: 55.8141,
      amcCode: 'RMF',
      lockinPeriod: 1096,
      annualInterestRate: 16.99,
      fundType: 'ELSS',
      imageUrl: '/images/Reliance.png',
      fundHouse: 'KARVY',
      morningStarRating: '4/5',
      valueResearchRating: '3/5',
      threeYearReturns: 29.7,
      fiveYearReturns: 23.3,
      minAmount: 500,
      minSipAmount: 500,
      minRedeemableAmount: 500,
      minRedeemableUnit: 5,
      productCode: 'RMFTSGP',
      exitLoad: null,
      priority: 1,
      type: 'ELSSEquity',
      productId: 2,
      fundFocus: null,
      supportedItemTypes: ['LUMPSUM_MF', 'SIP_MF'],
    },
    {
      fundName: 'SBI Magnum Taxgain Scheme',
      issuingAuthority: 'SBI Mutual Fund',
      year: 0,
      schemeCode: '018G',
      amfiSchemeCode: '105628',
      currentNav: 137.286,
      amcCode: 'L',
      lockinPeriod: 1096,
      annualInterestRate: 16.97,
      fundType: 'ELSS',
      imageUrl: '/images/SBI.png',
      fundHouse: 'CAMS',
      morningStarRating: '2/5',
      valueResearchRating: '2',
      threeYearReturns: 6.49,
      fiveYearReturns: 17,
      minAmount: 500,
      minSipAmount: 500,
      minRedeemableAmount: 500,
      minRedeemableUnit: 5,
      productCode: 'L018G',
      exitLoad: 0,
      priority: 62,
      type: 'ELSSEquity',
      productId: 63,
      fundFocus: null,
      supportedItemTypes: [],
    },
  ],
  minAmountForBucket: 2000,
  minSipAmountForBucket: 2000,
  minRedeemableAmountForBucket: 2000,
  minRedeemableUnitForBucket: 20,
  bucketId: 'c282bb93-6589-11e8-bedb-0a1ac60a80f8',
  sections: {
    title: 'Save Taxes',
    amount: 5000,
    bucketId: '19',
    rating: {
      rating: 4,
      returnLabel: '5Y Return',
      returns: '21.5',
    },
    actionButton: {
      actionButtonLabel: 'Invest Now',
      actionButtonLink: '/save',
      color: '',
    },
    benefits: {
      benefitsLabel: 'Benefits',
      benefits: [
        'Invest any amount',
        'Reduce Tax upto ₹46,800',
        'Shortest lock-in: 3 Years',
        'Earn more than PPF, Tax FD',
      ],
    },
    funds: {
      fundsLabel: 'Funds in the basket',
      funds: [
        {
          title: 'Aditya Birla Sun Life Tax Relief 96',
          image: 'Birla.png',
          fundLink: '#',
        },
        {
          title: 'DSP Tax Saver Fund',
          image: 'DSP.png',
          fundLink: '#',
        },
        {
          title: 'Axis Long Term Equity Fund',
          image: 'Axis.png',
          fundLink: '#',
        },
        {
          title: 'ICICI Prudential Long Term Equity Fund',
          image: 'ICICI.png',
          fundLink: '#',
        },
      ],
    },
    popupData: {
      basic: {
        title: 'Basic Details',
        details: [
          {
            label: 'Min. SIP',
            value: '₹2,000',
            tooltip: 'The actual values may vary based on funds',
          },
          {
            label: 'Min. Investment',
            value: '₹2,000',
          },
        ],
      },
      moreDetails: {
        title: 'More about these funds',
        details: [
          {
            header: 'Best suited for',
            content:
              'The scheme is suitable for salaried employees who want to save on huge tax outgo and simultaneously earn higher returns by locking in funds for a medium to higher investment horizon.',
          },
          {
            header: 'Why invest in these funds?',
            content:
              "The mutual fund scheme delivers higher returns as compared to its peer funds for the same level of risk taken. Additionally, the fund manager is better positioned to manage scheme's asset so as to formulate low-cost investment strategies that generate higher returns. With its unique investment style combined with more than 80% investment in large caps, the fund manager maintains a well-diversified portfolio to keep risk under manageable levels.",
          },
        ],
      },
      fundDetails: {
        title: 'You will be investing in the following funds',
        funds: [
          {
            name: 'Aditya Birla Sun Life Tax Relief 96',
            image: 'Birla.png',
            details: [
              {
                label: 'Rating',
                value: 4,
                type: 'rating',
              },
              {
                label: '5Y Return',
                value: '23.7%',
              },
              {
                label: 'AUM',
                value: '5,032 Cr',
              },
              {
                label: 'Category',
                value: 'Equity',
              },
            ],
          },
          {
            name: 'DSP Tax Saver Fund',
            image: 'DSP.png',
            details: [
              {
                label: 'Rating',
                value: 4,
                type: 'rating',
              },
              {
                label: '5Y Return',
                value: '22.0%',
              },
              {
                label: 'AUM',
                value: '3,905 Cr',
              },
              {
                label: 'Category',
                value: 'Equity',
              },
            ],
          },
          {
            name: 'Axis Long Term Equity Fund',
            image: 'Axis.png',
            details: [
              {
                label: 'Rating',
                value: 4,
                type: 'rating',
              },
              {
                label: '5Y Return',
                value: '21.8%',
              },
              {
                label: 'AUM',
                value: '16,161 Cr',
              },
              {
                label: 'Category',
                value: 'Equity',
              },
            ],
          },
          {
            name: 'ICICI Prudential Long Term Equity Fund (Tax Saving)',
            image: 'ICICI.png',
            details: [
              {
                label: 'Rating',
                value: 4,
                type: 'rating',
              },
              {
                label: '5Y Return',
                value: '18.5%',
              },
              {
                label: 'AUM',
                value: '5,034 Cr',
              },
              {
                label: 'Category',
                value: 'Equity',
              },
            ],
          },
        ],
      },
    },
  },
  enabled: false,
};

/*
 * Fund data Against fund productId
 * */
export const FUND_METADATA = {
  66: 'Better than market benchmark performance across last 5 & 10 years',
  3: 'Better than market benchmark performance across last 5 & 10 years',
  4: 'Effective at controlling losses in falling markets',
  52: 'Consistent returns across last 5 years',

  64: 'Well diversified fund with consistent returns',
  46: 'Has a high return vs investment ratio compared to most funds',
  82: 'Higher than market benchmark performance, lower risk',
  26: 'Higher than market benchmark performance, lower risk',
};

export const KEY_F2S_PAGE_STATE = 'key_f2s_page_state';



// WEBPACK FOOTER //
// ./constants/filingToSave.ts